import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import { SocialTab, socialsUrl } from '../util';

export const getLinkByTab = (tab: SocialTab) => `${socialsUrl}/${tab}`;

export function useSocialTabs() {
  const match = useRouteMatch<{ tab?: SocialTab }>();
  const { tab } = match.params;

  const { activeTabKey, activeTabName, tabsMap } = useMemo<{
    activeTabKey: number;
    activeTabName: SocialTab;
    tabsMap: SocialTab[];
  }>(() => {
    const { tabs, tabsMap } = Object.values(SocialTab).reduce<{
      tabs: Record<string, number>;
      tabsMap: SocialTab[];
    }>(
      ({ tabs, tabsMap }, value, index) => {
        return {
          tabs: {
            ...tabs,
            [value]: index,
          },
          tabsMap: [...tabsMap, value],
        };
      },
      { tabs: {}, tabsMap: [] }
    );

    return {
      activeTabKey: tab !== undefined ? tabs[tab] : 0,
      activeTabName: tab ?? SocialTab.All,
      tabsMap,
    };
  }, [tab]);

  return { activeTabKey, activeTabName, tabsMap };
}
